/**
 * Custom error class for 404 Not Found responses.
 * Used to distinguish 404 errors from other HTTP errors.
 */
class NotFoundError extends Error {
    constructor(message, resourceType = null) {
        super(message);
        this.name = 'NotFoundError';
        this.resourceType = resourceType; // 'election', 'vote', 'option', etc.
        this.statusCode = 404;

        // Maintains proper stack trace for where our error was thrown (only available on V8)
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, NotFoundError);
        }
    }
}

export default NotFoundError;
